import googleIcon from 'public/static/images/google-icon.png';
import facebookIcon from 'public/static/images/facebook-icon.png';
import emailIcon from 'public/static/images/email-icon.png';
import { colors, fonts } from 'components/styles/variables';
import { ReactNode } from 'react';
import AuthTypes from './AuthTypes';

interface Props {
  onClick(): void;
  type: AuthTypes;
  children: ReactNode;
  className?: string;
}

export default function AuthButton({ type, onClick, children, className }: Props): JSX.Element {
  return (
    <button className={`button ${type} ${className}`} onClick={onClick}>
      <i className="icon" />
      {children}
      <style jsx>
        {`
          .button {
            font-family: ${fonts.default};
            color: white;
            ser-select: none;
            border: 0;
            border-radius: 8px;
            font-size: 18px;
            font-weight: 600;
            cursor: pointer;
            padding: 0.7em 0 0.7em 1.7em;
            text-align: left;
            width: 100%;
          }

          .google {
            background-color: ${colors.GOOGLE};
          }

          .facebook {
            background-color: ${colors.FACEBOOK};
          }

          .email {
            background-color: ${colors.G3};
          }

          .icon {
            background-size: 25px;
            display: inline-block;
            height: 25px;
            line-height: 1em;
            margin-right: 0.6em;
            text-align: left;
            vertical-align: middle;
            width: 25px;
          }

          .google .icon {
            background-image: url(${googleIcon});
          }

          .facebook .icon {
            background-image: url(${facebookIcon});
          }

          .email .icon {
            background-image: url(${emailIcon});
          }
        `}
      </style>
    </button>
  );
}
